import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function BatchTask() {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { loadTasks() }, [])

  const loadTasks = async () => {
    setLoading(true)
    try {
      // 加载各类批量任务
      const res = await fetch(`${API}/batch-video/tasks`)
      const data = await res.json()
      if (data.success) {
        const batchTasks = (data.data || []).map(t => ({
          id: t.id,
          name: t.title || '批量生成任务',
          total: t.total_count || 1,
          done: t.completed_count || 0,
          status: t.status === 'completed' ? '已完成' : t.status === 'processing' ? '进行中' : '待处理'
        }))
        setTasks(batchTasks)
      }
    } catch (err) {
      console.error('加载失败', err)
    }
    setLoading(false)
  }

  const getProgress = (done, total) => total > 0 ? Math.round((done / total) * 100) : 0

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📋 批量任务</h2>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>任务名称</th>
              <th style={th}>进度</th>
              <th style={th}>状态</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</td></tr>
            ) : tasks.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无任务</td></tr>
            ) : tasks.map(t => (
              <tr key={t.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{t.name}</td>
                <td style={td}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ flex: 1, height: 8, background: '#f0f0f0', borderRadius: 4 }}>
                      <div style={{ width: getProgress(t.done, t.total) + '%', height: '100%', background: '#52c41a', borderRadius: 4 }} />
                    </div>
                    <span style={{ color: '#666', fontSize: 12, minWidth: 50 }}>{t.done}/{t.total}</span>
                  </div>
                </td>
                <td style={td}>
                  <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: t.status === '已完成' ? '#f6ffed' : '#e6f7ff', color: t.status === '已完成' ? '#52c41a' : '#1890ff' }}>
                    {t.status}
                  </span>
                </td>
                <td style={td}>
                  <button onClick={loadTasks} style={{ padding: '4px 12px', background: '#f5f5f5', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>刷新</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
